import { useLocation } from 'react-router-dom';
import Container from 'portal/Container';
import Loading from '@opploans/loading-component/Loading';
import React from 'react';

function Redirect() {
  const { pathname, search } = useLocation();
  window.location.href = `${pathname}${search}`;

  return (
    <Container noBackground>
      <Loading />
    </Container>
  );
}

export default Redirect;
